export default {
  sidebarItems: state => state.items
};
